import { decamelizeKeys } from 'humps'
import callApi from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { IGetEquipmentResponse } from 'apps/fleet-planner/types/equipment'
import { IFetchEquipmentParams } from 'apps/fleet-planner/utils/actions/equipment'

/**
 * Fetches all trailer/truck entities
 * @param {IFetchEquipmentParams} params - Any query params
 * @method GET
 */
export const fetchEquipment = (
  params: IFetchEquipmentParams = {}
): Promise<IGetEquipmentResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.equipment,
    method: 'GET',
    params: decamelizeKeys(params),
  })
}
